module.exports = __webpack_public_path__ + "static/img/coreTechnology_5.9cd072b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/coreTechnology_5.jpg
// module id = 2uoP
// module chunks = 0